import { ENV } from "../utils";

export class EPP {
  baseApi = ENV.BASE_API;

  async getEPPs(accessToken, active = true) {
    const url = `${this.baseApi}/epps?active=${active}`;
    const response = await fetch(url, { headers: { Authorization: `Bearer ${accessToken}` } });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async getEPP(accessToken, id) {
    const response = await fetch(`${this.baseApi}/epp/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createEPP(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-epp`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateEPP(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-epp/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteEPP(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-epp/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async checkEPPStock(accessToken, { names, site }) {
    const response = await fetch(`${this.baseApi}/epp-stock-check`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify({ names, site }),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateEPPStock(accessToken, id, { site, quantity, location }) {
    const response = await fetch(`${this.baseApi}/update-epp-stock/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify({ site, quantity, location }),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
